import React, { useEffect, useState } from 'react';
import { PageHeader, Icon, Button, PageHeaderControl, Dropdown, DropdownTrigger } from '@salesforce/design-system-react';
import UserTable from './userTable';
import { useDispatch, useSelector } from 'react-redux';
import { authSelector } from '../../../store/auth/slice';
import AddSuperAdmin from '../../../components/Modal/addSuperAdmin';
import { getTimeIntervalText } from '../../../utilities/datetime';
import { superAdminSelector } from '../../../store/superAdmin/slice';

const Users = () => {
  const { user } = useSelector(authSelector);
  const { superAdmin } = useSelector(superAdminSelector);
  const [addSuperAdminModal, setAddSuperAdminModal] = useState(false);
  const [APICalledTime, setAPICalledTime] = useState(new Date());
  const [data, setData] = useState([]);
  const [text, setText] = useState('Recently updated');

  useEffect(() => {
    setAPICalledTime(new Date());
    const data = getTimeIntervalText(APICalledTime);
    setText(data);
  }, [superAdmin, data])

  useEffect(() => {
    const interval = setInterval(() => {
      const dat = getTimeIntervalText(APICalledTime);
      setText(dat);
    }, 20000);

    return () => clearInterval(interval);
  }, [APICalledTime]);

  // const actions = () => (
  //   <React.Fragment>
  //     <PageHeaderControl>
  //       {user?.role === 'super_admin' && (
  //         <Button label="Add Super Admin" onClick={() => setAddSuperAdminModal(true)} />
  //       )}
  //     </PageHeaderControl>
  //   </React.Fragment>
  // );

  return (
    <>
      <div>
        <PageHeader
          icon={
            <Icon
              assistiveText={{ label: 'User' }}
              category="standard"
              name="catalog"
              containerStyle={{
                backgroundColor: '#48C3CC',
              }}
            />
          }
          info={`${data ? data.length : 0} data • ${text}`}
          label="Administration"
          // title="Users"
          joined
          // variant="record-home"
          // onRenderActions={actions}
          onRenderActions={() => (
            <>
              <PageHeaderControl>
                {user?.role === 'super_admin' && (
                  <Button label="Add Super Admin" onClick={() => setAddSuperAdminModal(true)} />
                )}
              </PageHeaderControl>
            </>
          )}
          truncate
          variant="object-home"
          title={
            <h1 className="slds-page-header__title slds-p-right_x-small">
              <Dropdown id="page-header-dropdown-object-home-header">
                <DropdownTrigger>
                  <Button
                    className="slds-button_reset slds-type-focus"
                    iconCategory="utility"
                    iconName="down"
                    iconPosition="right"
                    label="Users"
                    responsive
                    variant="base"
                  />
                </DropdownTrigger>
              </Dropdown>
            </h1>
          }
        />
      </div>
      <div>
        <UserTable setData={setData} />
      </div>
      <AddSuperAdmin
        openModal={addSuperAdminModal}
        closeModal={() => setAddSuperAdminModal(false)}
      />
    </>
  );
};

export default Users;
